<script lang="ts">
    interface Props {
        element: HTMLElement
    }

    let { element }: Props = $props()

    let me: HTMLElement | undefined = $state()

    const attrs = $state({})
    let classToAdd: string
    let initialClass: string | undefined
    let removeClass: string
    let classes: Set<string> = $state(new Set())
    let poppedInView = false
    let scrollY: number = $state(0)
    let offset: number = 0

    for (const attribute of element.attributes) {
        if (attribute.name === 'class-in-view') {
            classToAdd = attribute.value
        } else if (attribute.name === 'data-class-remove') {
            removeClass = attribute.value
        } else if (attribute.name === 'data-class-initial') {
            initialClass = attribute.value
        } else if (attribute.name === 'class') {
            classes = new Set(attribute.value.split(' '))
        } else if (attribute.name === 'data-view-offset') {
            offset = parseInt(attribute.value, 10)
        } else {
            attrs[attribute.name] = attribute.value
        }
    }
    if (initialClass) classes.add(initialClass)

    function isPartiallyInViewport(el: HTMLElement, offset: number = 0) {
        const rect = el.getBoundingClientRect()
        const vph = window.innerHeight || document.documentElement.clientHeight

        // rect.top == 0 means the element is exactly at the top of the viewport
        return rect.top + offset <= vph && rect.bottom - offset >= 0
    }

    function checkIntoView(scrollY: number) {
        if (!me || poppedInView) return
        if (isPartiallyInViewport(me, offset)) {
            classes.add(classToAdd)
            if (removeClass) classes.delete(removeClass)
            classes = classes
            if (!poppedInView) {
                poppedInView = true
            }
            // } else {
            //     classes.delete(classToAdd)
            //     classes = classes
            //     if (poppedInView) {
            //         poppedInView = false
            //         console.log('Poped out of view:', me)
            //     }
        }
    }
    $effect(() => {
        checkIntoView(scrollY)
    })
</script>

<svelte:window bind:scrollY />

<div bind:this={me} class={[...classes].join(' ')} {...attrs}>{@html element.innerHTML}</div>
